import {
  DecoratorNode,
  ElementNode,
  $parseSerializedNode,
  $getNodeByKey,
  $getSelection,
  $isRangeSelection,
  $createTextNode,
  $getRoot,
  $isTextNode,
} from 'lexical';
import React from 'react';
import { MarkNode } from '@lexical/mark';
import { CommentMarkNode } from './CommentMarkNode';

// Mention Node

export class MentionNode extends DecoratorNode {
  __name;
  // REQUIRED
  static getType() {
    return 'mention';
  }
  static clone(node) {
    return new MentionNode(node.__name, node.__key);
  }
  //FIXES ERROR
  static importJSON(serializedNode) {
    return new MentionNode(serializedNode.name);
  }
  // for saving
  exportJSON() {
    return {
      type: 'mention',
      name: this.__name,
      version: 1,
    };
  }
  isInline() {
    return true;
  }
  constructor(name = 'User', key) {
    super(key);
    this.__name = name;
  }
  createDOM() {
    const span = document.createElement('span');
    span.style.color = '#0C66E4';
    span.style.background = '#E9F2FF';
    span.style.padding = '2px 6px';
    span.style.borderRadius = '4px';
    span.style.fontWeight = '500';
    span.innerText = '@' + this.__name;
    return span;
  }
  updateDOM() {
    return false;
  }
}

// Layout Node (columns)

export class LayoutNode extends ElementNode {
  static getType() {
    return 'layout';
  }
  static clone(node) {
    return new LayoutNode(node.__key);
  }
  createDOM() {
    const div = document.createElement('div');
    // div.style.display = 'grid';
    // div.style.gridTemplateColumns = '1fr 1fr';
    // div.style.gap = '10px';
    // div.style.margin = '10px 0';
    div.className = 'editor-layout';
    return div;
  }
  updateDOM() {
    return false;
  }
}
export class LayoutColumnNode extends ElementNode {
  static getType() {
    return 'layout-column';
  }
  static clone(node) {
    return new LayoutColumnNode(node.__key);
  }
  createDOM() {
    const div = document.createElement('div');
    div.className = 'editor-layout-column';
    return div;
  }
  updateDOM() {
    return false;
  }
}

// IMAGE & FILE NODE

export class UploadNode extends DecoratorNode {
  static getType() {
    return 'upload';
  }

  constructor(name, url, isImage, attachmentId, mimeType, key) {
    super(key);
    this.__name = name;
    this.__url = url;
    this.__isImage = isImage;
    this.__attachmentId = attachmentId;
    this.__mimeType = mimeType || '';
  }

  static clone(node) {
    return new UploadNode(
      node.__name,
      node.__url,
      node.__isImage,
      node.__attachmentId,
      node.__mimeType,
      node.__key,
    );
  }

  exportJSON() {
    return {
      type: 'upload',
      version: 1,
      name: this.__name,
      url: this.__url,
      isImage: this.__isImage,
      attachmentId: this.__attachmentId,
      mimeType: this.__mimeType,
    };
  }

  static importJSON(serializedNode) {
    return new UploadNode(
      serializedNode.name,
      serializedNode.url,
      serializedNode.isImage,
      serializedNode.attachmentId,
      serializedNode.mimeType,
    );
  }

  // static clone(node) {
  //   return new UploadNode(
  //     node.__name,
  //     node.__url,
  //     node.__isImage,
  //     node.__attachmentId,
  //     node.__key,
  //   );
  // }
  // constructor(name, url, isImage, attachmentId, key) {
  //   super(key);
  //   this.__name = name;
  //   this.__url = url;
  //   this.__isImage = isImage;
  //   this.__attachmentId = attachmentId;
  // }
  // static importJSON(serializedNode) {
  //   return new UploadNode(
  //     serializedNode.name,
  //     serializedNode.url,
  //     serializedNode.isImage,
  //     serializedNode.attachmentId,
  //   );
  // }
  // exportJSON() {
  //   return {
  //     type: 'upload',
  //     version: 1,
  //     name: this.__name,
  //     url: this.__url,
  //     isImage: this.__isImage,
  //     attachmentId: this.__attachmentId,
  //   };
  // }
  createDOM() {
    const wrapper = document.createElement('div');
    wrapper.style.cssText =
      'margin: 10px 0; position: relative; display: inline-block;';

    const deleteBtn = document.createElement('button');
    deleteBtn.innerText = '✕';
    deleteBtn.style.cssText = `
    position: absolute; top: 4px; right: 4px;
    background: rgba(0,0,0,0.5); color: white;
    border: none; border-radius: 50%;
    width: 22px; height: 22px;
    cursor: pointer; font-size: 12px;
    display: flex; align-items: center; justify-content: center;
    z-index: 10;
  `;
    deleteBtn.onclick = (e) => {
      e.stopPropagation();
      if (window.__deleteAttachment) {
        window.__deleteAttachment(this.__attachmentId);
      }
    };

    if (this.__isImage) {
      const img = document.createElement('img');
      img.src = this.__url;
      img.alt = this.__name;
      img.style.cssText =
        'max-width: 100%; border-radius: 8px; display: block;';
      wrapper.appendChild(img);
      wrapper.appendChild(deleteBtn);
    } else {
      const link = document.createElement('a');
      link.href = this.__url;
      link.target = '_blank';
      link.innerText = '📎 ' + this.__name;
      link.style.cssText = `
      display: inline-block; padding: 8px 36px 8px 12px;
      background: #F4F5F7; border-radius: 6px;
      text-decoration: none; color: #0C66E4;
    `;
      wrapper.appendChild(link);
      wrapper.appendChild(deleteBtn);
    }

    return wrapper;
  }
  updateDOM() {
    return false;
  }
}

// DATE NODE
export class DateNode extends DecoratorNode {
  static getType() {
    return 'date';
  }
  static clone(node) {
    return new DateNode(node.__date, node.__key);
  }
  constructor(date = '', key) {
    super(key);
    this.__date = date;
  }
  static importJSON(serializedNode) {
    return new DateNode(serializedNode.date);
  }
  exportJSON() {
    return {
      type: 'date',
      version: 1,
      date: this.__date,
    };
  }
  createDOM() {
    const span = document.createElement('span');
    span.innerText = '📅 ' + this.__date;
    span.style.background = '#F4F5F7';
    span.style.padding = '4px 8px';
    span.style.borderRadius = '6px';
    span.style.fontSize = '13px';
    span.style.margin = '0 4px';
    span.style.display = 'inline-block';
    return span;
  }
  updateDOM() {
    return false;
  }
}

// STATUS NODE
export class StatusNode extends DecoratorNode {
  static getType() {
    return 'status';
  }
  static clone(node) {
    return new StatusNode(node.__text, node.__color, node.__key);
  }
  constructor(text = 'SET STATUS', color = '#DFE1E6', key) {
    super(key);
    this.__text = text;
    this.__color = color;
  }
  static importJSON(serializedNode) {
    return new StatusNode(serializedNode.text, serializedNode.color);
  }
  exportJSON() {
    return {
      type: 'status',
      version: 1,
      text: this.__text,
      color: this.__color,
    };
  }

  createDOM() {
    const span = document.createElement('span');
    span.innerText = this.__text;
    span.style.backgroundColor = this.__color;
    span.style.padding = '4px 10px';
    span.style.borderRadius = '6px';
    span.style.fontSize = '12px';
    span.style.fontWeight = '500';
    span.style.display = 'inline-block';
    span.style.margin = '0 4px';
    span.contentEditable = 'false';
    return span;
  }
  updateDOM() {
    return false;
  }
}

// CODE BLOCK NODE

export class CodeBlockNode extends ElementNode {
  static getType() {
    return 'codeblock';
  }
  static clone(node) {
    return new CodeBlockNode(node.__language, node.__key);
  }
  constructor(language = 'javascript', key) {
    super(key);
    this.__language = language;
  }
  static importJSON(serializedNode) {
    return new CodeBlockNode(serializedNode.language);
  }
  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'codeblock',
      language: this.__language,
      version: 1,
    };
  }
  createDOM() {
    const pre = document.createElement('pre');
    pre.style.background = '#C0C0C0';
    pre.style.color = 'black';
    pre.style.padding = '12px';
    pre.style.borderRadius = '6px';
    pre.style.fontFamily = 'monospace';
    pre.style.margin = '8px 0';
    pre.style.borderLeft = '4px solid #696969';
    return pre;
  }
  updateDOM() {
    return false;
  }
}

// PANEL NODE

export class PanelNode extends ElementNode {
  static getType() {
    return 'panel';
  }

  static clone(node) {
    return new PanelNode(node.__typeName, node.__key);
  }

  constructor(typeName = 'info', key) {
    super(key);
    this.__typeName = typeName;
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      type: 'panel',
      typeName: this.__typeName,
      version: 1,
    };
  }

  static importJSON(serializedNode) {
    return new PanelNode(serializedNode.typeName);
  }

  createDOM() {
    const wrapper = document.createElement('div');
    wrapper.className = `panel panel-${this.__typeName}`;

    const icon = document.createElement('span');
    icon.className = 'panel-icon';
    icon.contentEditable = 'false';

    const icons = {
      info: 'ℹ️',
      success: '✅',
      warning: '⚠️',
      error: '❌',
      note: '📝',
    };

    icon.textContent = icons[this.__typeName] || 'ℹ️';

    wrapper.append(icon);

    return wrapper;
  }

  updateDOM(prevNode, dom) {
    if (prevNode.__typeName !== this.__typeName) {
      dom.className = `panel panel-${this.__typeName}`;
    }
    return false;
  }

  // ⭐ ADD THESE METHODS

  isInline() {
    return false;
  }

  canBeEmpty() {
    return false;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }
}

//DIVIDER NODE

export class DividerNode extends ElementNode {
  static getType() {
    return 'divider';
  }

  static clone(node) {
    return new DividerNode(node.__key);
  }

  static importJSON() {
    return new DividerNode();
  }

  exportJSON() {
    return {
      type: 'divider',
      version: 1,
      children: [], // MUST EXIST
      direction: null,
      format: '',
      indent: 0,
    };
  }

  createDOM() {
    const hr = document.createElement('hr');
    hr.style.margin = '16px 0';
    hr.style.border = 'none';
    hr.style.borderTop = '2px solid #ddd';

    return hr;
  }

  updateDOM() {
    return false;
  }

  isInline() {
    return false;
  }
}

//CHECKBOX NODE

export class CheckboxNode extends ElementNode {
  static getType() {
    return 'checkbox';
  }

  static clone(node) {
    return new CheckboxNode(node.__checked, node.__key);
  }

  constructor(checked = false, key) {
    super(key);
    this.__checked = checked;
  }

  static importJSON(serializedNode) {
    return new CheckboxNode(serializedNode.checked);
  }

  exportJSON() {
    return {
      type: 'checkbox',
      version: 1,
      checked: this.__checked,
      children: this.getChildren().map((child) => child.exportJSON()),
      direction: null,
      format: '',
      indent: 0,
    };
  }

  createDOM() {
    const container = document.createElement('div');
    container.style.display = 'flex';
    container.style.alignItems = 'center';
    container.style.gap = '8px';
    container.style.margin = '6px 0';

    const input = document.createElement('input');
    input.type = 'checkbox';
    input.checked = this.__checked;

    input.onclick = (e) => {
      e.stopPropagation();
      this.getWritable().__checked = input.checked;
    };

    container.appendChild(input);

    return container;
  }

  updateDOM() {
    return false;
  }
}

//COMMENT NODE

export function restoreHighlights(editor, comments) {
  const activeIds = new Set(comments.map((c) => String(c.id)));

  editor.update(() => {
    const root = $getRoot();

    root.getAllTextNodes().forEach((node) => {
      const parent = node.getParent();
      if (parent?.getType() === 'comment-mark') {
        if (!activeIds.has(String(parent.__commentId))) {
          parent.replace(...parent.getChildren());
        }
      }
    });

    const blockMap = new Map();

    comments.forEach((c) => {
      const pos = c.inline_position;
      if (!pos?.block_id) return;
      if (pos.start_offset == null || pos.end_offset == null) return;
      if (pos.start_offset >= pos.end_offset) return;

      if (!blockMap.has(pos.block_id)) {
        blockMap.set(pos.block_id, []);
      }
      blockMap.get(pos.block_id).push(c);
    });

    blockMap.forEach((blockComments, blockId) => {
      const block = $getNodeByKey(blockId);
      if (!block) return;

      const textNodes = getAllTextNodesInBlock(block);

      blockComments.sort(
        (a, b) =>
          b.inline_position.start_offset - a.inline_position.start_offset,
      );

      blockComments.forEach((comment) => {
        const { start_offset, end_offset } = comment.inline_position;

        const freshTextNodes = getAllTextNodesInBlock(block);

        let offset = 0;
        freshTextNodes.forEach((node) => {
          if (!$isTextNode(node)) return;

          const text = node.getTextContent();
          const nodeStart = offset;
          const nodeEnd = offset + text.length;

          const overlapStart = Math.max(start_offset, nodeStart);
          const overlapEnd = Math.min(end_offset, nodeEnd);

          if (overlapStart < overlapEnd) {
            if (isAlreadyHighlighted(node, comment.id)) {
              offset = nodeEnd;
              return;
            }

            const localStart = overlapStart - nodeStart;
            const localEnd = overlapEnd - nodeStart;

            splitAndWrapTextNode(node, localStart, localEnd, comment.id);
          }

          offset = nodeEnd;
        });
      });
    });
  });
}

function getAllTextNodesInBlock(node) {
  const textNodes = [];

  function collect(n) {
    if ($isTextNode(n)) {
      textNodes.push(n);
      return;
    }
    const children = n.getChildren?.();
    if (children) {
      children.forEach(collect);
    }
  }

  collect(node);
  return textNodes;
}

function splitAndWrapTextNode(node, start, end, commentId) {
  if (!node || start >= end) return;

  const parts = node.splitText(start, end);
  const selectedNode = start === 0 ? parts[0] : parts[1];

  if (!selectedNode) return;

  const mark = new CommentMarkNode(commentId);
  selectedNode.insertBefore(mark);
  mark.append(selectedNode);
}

function isAlreadyHighlighted(node, commentId) {
  let parent = node.getParent();

  while (parent) {
    if (
      parent.getType() === 'comment-mark' &&
      parent.__commentId === commentId
    ) {
      return true;
    }
    parent = parent.getParent();
  }

  return false;
}

export function highlightSelection(editor, commentId) {
  editor.update(() => {
    const selection = $getSelection();
    if (!$isRangeSelection(selection) || selection.isCollapsed()) return;

    const nodes = selection.getNodes();
    nodes.forEach((node) => {
      if (!$isTextNode(node)) return;
      if (isAlreadyHighlighted(node, commentId)) return;

      const text = node.getTextContent();
      let start = 0;
      let end = text.length;

      if (node === selection.anchor.getNode()) {
        start = selection.anchor.offset;
      }
      if (node === selection.focus.getNode()) {
        end = selection.focus.offset;
      }

      if (start >= end) return;
      if (!node.isAttached()) return;

      splitAndWrapTextNode(node, start, end, commentId);
    });
  });
}
